import { Blockquote, Amazon, Series, InternalLink, Twitter } from '../../../../src/components/blog';
import series from '../../../../config/series';
import * as React from 'react';
export default {
  Blockquote,
  Amazon,
  Series,
  InternalLink,
  Twitter,
  series,
  React
};